import * as React from 'react';
import { Modal } from 'react-bootstrap';
import { ProfilePhoto } from '@/domains/profiles';
import ProTip from './ProTip';

// Context
import { ProfileFormContext } from '../ProfileEditForm';
import { ACTIONS } from './ProfileFormReducer';

const submitProfileAvatarDeleteField = (profile, dispatch, authenticity_token, setFiles) => {
  const profileData = {
    delete_avatar: '1',
    profile: {
      delete_avatar: '1',
    }
  }

  const url = `/profiles/${profile.id}.json`
  const method = "PATCH"
  const headers = {
    "X-CSRF-Token": authenticity_token,
    "Content-Type": "application/json",
  }

  fetch(url, {
    method: method,
    headers: headers,
    body: JSON.stringify(profileData),
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      // throw new Error("Network response was not ok.")
    })
    .then((response) => {
      // Dispatch SET_FIELD avatar to null
      dispatch({
        type: ACTIONS.SET_FIELD,
        payload: { avatar_url: "/images/missing.svg" },
      })
      setFiles([1])
    })
    .catch((error) => console.error("Error"))
}

export default function PhotoPopup() {
  // Show Popup State
  const [modalOpen, setModalOpen] = React.useState(false)

  // Image Error State
  const [imageError, setImageError] = React.useState(false)

  // Context
  const [state, dispatch] = React.useContext(ProfileFormContext)

  // Get Profile Avatar
  const avatar = state.profile.avatar_url

  // closeModal
  const closeModal = () => setModalOpen(false)
  const openModal = () => setModalOpen(true)

  // Set Avatar URL
  const setAvatarURL = (url) => {
    dispatch({
      type: ACTIONS.SET_FIELD,
      payload: { avatar_url: url }
    })

    closeModal()
  }

  // Check to see if avatar resolves to 404
  const checkAvatar = () => {
    var img = new Image()

    img.onload = function () {
      setImageError(false)
    }

    img.onerror = function () {
      setImageError(true)
    }

    img.src = avatar
  }

  // Run checkAvatar once on mount
  React.useEffect(() => checkAvatar(), [])

  return (
    <>
      <div className="form-section-card">
        <h3><i className="fas fa-camera"></i> Profile Photo</h3>

        {/* Show Avatar if it exists */}
        <div className="text-center mb-4">
          {avatar ? (
            <div
              className="position-relative d-inline-block cursor-pointer"
              onClick={openModal}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={avatar}
                className="rounded-circle img-fluid shadow-lg"
                style={{
                  width: '150px',
                  height: '150px',
                  objectFit: 'cover',
                  border: '4px solid #fff',
                  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
                }}
                alt="Profile"
              />
              <div
                className="position-absolute bottom-0 end-0 bg-primary rounded-circle p-2"
                style={{
                  transform: 'translate(-10px, -10px)',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                }}
              >
                <i className="fas fa-edit text-white" style={{ fontSize: '0.875rem' }}></i>
              </div>
            </div>
          ) : (
            <div
              className="modern-file-upload mx-auto"
              style={{ maxWidth: '300px', cursor: 'pointer' }}
              onClick={openModal}
            >
              <i className="fas fa-user-circle upload-icon"></i>
              <div className="upload-text">
                <strong>Upload Profile Photo</strong>
              </div>
              <div className="upload-hint">
                Click to select an image
              </div>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="text-center">
          <button className="modern-btn btn-primary mx-2" onClick={openModal}>
            <i className="fas fa-camera"></i>
            {avatar ? 'Change Photo' : 'Upload Photo'}
          </button>
          {avatar && (
            <button
              className="modern-btn btn-secondary mx-2"
              onClick={() => submitProfileAvatarDeleteField(state.profile, dispatch, state.authenticity_token, undefined)}
            >
              <i className="fas fa-trash"></i> Remove Photo
            </button>
          )}
        </div>
        <ProTip variant="green" icon="fas fa-camera">
          A professional photo significantly increases your chances of getting hired. Make sure it's clear and shows you in professional attire.
        </ProTip>
      </div>

      {/* Modern Modal */}
      <Modal show={modalOpen} onHide={closeModal} centered size="lg">
        <Modal.Header
          closeButton
          style={{
            background: 'linear-gradient(135deg, #085ec8 0%, #176fc9 100%)',
            color: 'white',
            borderBottom: 'none',
            borderRadius: '16px 16px 0 0',
            padding: '1.5rem'
          }}
        >
          <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '1.25rem', fontWeight: 600 }}>
            <i className="fas fa-camera"></i> Profile Photo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '2rem' }}>
          <div className="text-center mb-3" style={{ color: '#6c757d' }}>
            <i className="fas fa-lightbulb" style={{ color: '#fe6718', marginRight: '0.5rem' }}></i>
            <strong>Tip:</strong> A photo helps your profile stand out and builds trust with potential employers
          </div>
          <ProfilePhoto profile={state.profile} authenticity_token={state.authenticity_token} callback={setAvatarURL} />
        </Modal.Body>
      </Modal>
    </>
  )
}
